<template>
  <div
    :id="id"
    :class="`expandingButton ${classes}`"
    :style="
      isHovered
        ? `border: 1.5px solid ${color};background: ${color}; max-width: ${maxWidth}`
        : ''
    "
    @mouseover="handleMouseOver"
    @mouseout="handleMouseOut"
  >
    <component
      :is="icon"
      v-if="icon"
      :color="isHovered ? '#FFFFFF' : color"
      :size="12"
    />
    <span
      v-if="isHovered"
      class="text tw-text-white tw-text-center tw-text-[12px] tw-not-italic tw-font-medium tw-leading-[100%]"
      >{{ text }}</span
    >
  </div>
</template>

<script setup lang="ts">
import { Ref, ref } from "vue";

defineProps({
  icon: {
    type: Object,
    required: true,
  },
  color: {
    type: String,
    default: "#387DFF",
  },
  text: {
    type: String,
    default: "Click",
  },
  maxWidth: {
    type: String,
    default: "77px",
  },
  classes: {
    type: String,
    default: "",
  },
  id: {
    type: String,
    required: false,
    default: "",
  },
});

const isHovered: Ref<boolean> = ref(false);

const setIsHovered = (value: boolean) => {
  isHovered.value = value;
};

const handleMouseOver = () => {
  setTimeout(() => {
    setIsHovered(true);
  }, 0);
};

const handleMouseOut = () => {
  setTimeout(() => {
    setIsHovered(false);
  }, 0);
};
</script>

<style scoped lang="scss">
.expandingButton {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  border-radius: 100px;
  border: 1.5px solid #eff0f1;
  background: #fff;
  width: 100%;
  height: 100%;
  min-width: 28px;
  min-height: 28px;
  max-width: 28px;
  max-height: 28px;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
  user-select: none;

  &:hover {
    padding: 8px 12px;
  }

  &:active {
    transform: scale(0.96);
  }
}
</style>
